// Material UI
import { makeStyles } from '@material-ui/core';
import { neutral } from '../../shared/styles/colors';

export default makeStyles(theme => ({
  body: {
    [theme.breakpoints.up('sm')]: {},
    [theme.breakpoints.up('md')]: {
      paddingLeft: 43,
      paddingRight: 43,
      paddingTop: 52,
    },
  },
  headerRoot: {
    gridTemplateColumns: 'auto auto min-content',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'min-content auto min-content',
      borderBottom: 'none',
      padding: '12px 4px 14px 43px',
    },
  },
  paper: {
    [theme.breakpoints.up('md')]: {
      width: 576,
      height: 352,
    },
  },
  icon: {
    gridArea: 'icon',
    justifySelf: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 164,
      paddingBottom: 22,
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  iconImage: {
    width: 79,
    height: 79,
    [theme.breakpoints.up('sm')]: {
      width: 118,
      height: 118,
    },
    [theme.breakpoints.up('md')]: {
      width: 54,
      height: 54,
    },
  },
  text: {
    gridArea: 'text',
    alignSelf: 'center',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 52,
    fontSize: 16,
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
      fontSize: 18,
      marginBottom: 0,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      marginBottom: 0,
      justifySelf: 'left',
    },
  },
  info: {
    gridArea: 'info',
    fontSize: 14,
    [theme.breakpoints.up('sm')]: {
      textAlign: 'center',
      fontSize: 18,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      textAlign: 'left',
    },
  },
  root: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 70,
    display: 'grid',
    gridGap: 12,
    gridTemplateAreas: `"icon"
                        " text"
                        "info"`,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      gridTemplateRows: 'min-content',
      gridTemplateColumns: 'min-content',
      gridGap: 12,
      gridTemplateAreas: `"icon text"
                        "info info"`,
    },
  },
  buttonSubmit: {},
  footerButtonSubmit: {
    gridArea: 'footerButtonSubmit',
    justifySelf: 'end',
  },
  containerButtons: {
    borderTop: `1px solid ${neutral.D10}`,
    position: 'fixed',
    bottom: 0,
    width: '100%',
    gap: 14,
    padding: 16,
    display: 'grid',
    gridTemplateAreas: `"footerButtonSubmit"
                        "footerRejectButton"`,
  },
}));
